<script setup lang="ts">
import { type PropType } from 'vue';
import GaiaText from '../base/GaiaText.vue';
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /** Uppercase panel label, e.g. "Prompt", "Outcomes", "Actions". */
  label: {
    type: String,
    default: undefined,
  },
  /** tinted = the soft panel inside a card; plain = white on a tinted parent. */
  tone: {
    type: String as PropType<'tinted' | 'plain'>,
    default: 'tinted',
  },
});

const border = gaiaNeutral.borderSubtle;
const tinted = gaiaNeutral.surfaceSoft;
const plain = gaiaNeutral.surface;
</script>

<template>
  <!-- Labelled sub-panel inside an item card (Playbooks mock: Prompt,
       Outcomes, Response type, Actions). #actions holds a trailing control
       such as "Add action". -->
  <n-flex vertical :size="7" class="gaia-sub-panel" :class="props.tone">
    <n-flex v-if="props.label || $slots.actions" align="center" :size="8" :wrap="false">
      <gaia-text v-if="props.label" variant="label" size="nano" tone="subtle">
        {{ props.label }}
      </gaia-text>
      <n-flex
        v-if="$slots.actions"
        inline
        align="center"
        :size="8"
        :wrap="false"
        :style="{ marginLeft: 'auto', flex: 'none' }"
      >
        <slot name="actions" />
      </n-flex>
    </n-flex>
    <slot />
  </n-flex>
</template>

<style scoped>
.gaia-sub-panel {
  min-width: 0;
  padding: 12px 13px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
}

.tinted {
  background: v-bind(tinted);
}

.plain {
  background: v-bind(plain);
}
</style>
